import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Pendientes from "@/pages/Pendientes";
import AdminItems from "@/pages/AdminItems";
import AdminUsuarios from "@/pages/AdminUsuarios";
import AdminRoles from "@/pages/AdminRoles";
import AdminSucursales from "@/pages/AdminSucursales";
import AdminHelados from "@/pages/AdminHelados";
import AdminPaletas from "@/pages/AdminPaletas";
import Helados from "@/pages/Helados";
import Paletas from "@/pages/Paletas";
import Transportes from "@/pages/Transportes";

/** Root redirect: send user to their first available tab. */
function RootRedirect() {
  const { user } = useAuth();
  const isManager = !!user?.role?.is_manager;
  const tabs = user?.tabs || [];
  const first =
    (isManager && "piso") ||
    (tabs.includes("piso") && "piso") ||
    (tabs.includes("produccion") && "produccion") ||
    (tabs.includes("helados") && "helados") ||
    (tabs.includes("paletas") && "paletas") ||
    "piso";
  return <Navigate to={`/${first}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <RootRedirect />
              </ProtectedRoute>
            }
          />
          <Route
            path="/piso"
            element={
              <ProtectedRoute>
                <Layout><Dashboard category="piso" /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/produccion"
            element={
              <ProtectedRoute>
                <Layout><Dashboard category="produccion" /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/helados"
            element={
              <ProtectedRoute>
                <Layout><Helados /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/paletas"
            element={
              <ProtectedRoute>
                <Layout><Paletas /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/transporte"
            element={
              <ProtectedRoute managerOnly>
                <Layout><Transportes /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pendientes"
            element={
              <ProtectedRoute managerOnly>
                <Layout><Pendientes /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/items"
            element={
              <ProtectedRoute editorOrManager>
                <Layout><AdminItems /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/helados"
            element={
              <ProtectedRoute editorOrManager>
                <Layout><AdminHelados /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/paletas"
            element={
              <ProtectedRoute editorOrManager>
                <Layout><AdminPaletas /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <ProtectedRoute managerOnly>
                <Layout><AdminUsuarios /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/roles"
            element={
              <ProtectedRoute managerOnly>
                <Layout><AdminRoles /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/sucursales"
            element={
              <ProtectedRoute managerOnly>
                <Layout><AdminSucursales /></Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
